import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { add_bank_data, get_bank_regex } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { Pagination, SearchAndAddBtn, THead } from '../../Components';
import { Card, CardBody, IconButton, Checkbox, Spinner } from "@material-tailwind/react";
import { BiEdit } from 'react-icons/bi';
import { RiDeleteBinLine } from 'react-icons/ri';
import BankRegexModel from '../../Components/Modals/BankRegexModel';

const BankRegex = ({ title }) => {
    const { formData, permissions, tokenType, setIsLoading, setCurrentPageData, setCurrentPage, setPerPage, setDeleteUpdateYes, setConfirmationModalShow, setDeleteUpdateItem, confirmationModalShow, setAddEditDeleteTag, handleChange, setFormData, setApiResponse, isLoading, handleOpen, setTotalPage, sortData, isAscending, perPage, search, filterDropdown, setDeleteUpdateTag, currentPage, deleteUpdateYes, deleteUpdateTag, totalPage } = useContext(NewContext);
    const [bankData, setBankData] = useState([]);
    const simpleFields = [
        { name: "Country Code", sortable: false, field: 'countryCode' },
        { name: "Bank Name", sortable: false, field: 'bankName' },
        { name: "Bank Regex", sortable: false, field: 'bankRegex' },
    ];
    const totalFields = simpleFields.length + 2;

    const handleSubmit = async (e) => {
        e.preventDefault();
        let bankRegex;
        setIsLoading(true);
        bankRegex = await add_bank_data(formData)
        if (bankRegex) {
            setApiResponse(bankRegex);
            const { message, status } = bankRegex;
            if (status) {
                toast.success(message);
                setFormData({
                    countryCode: "",
                    name: "",
                    regex: ""
                });
                getBankRegexData();
                setIsLoading(false);
            } else {
                toast.error(message);
            };
        }
    }

    const getBankRegexData = async (_currentPage = 1, sortName = sortData, sortType = isAscending) => {
        setIsLoading(true)
        try {
            const getAsset = await get_bank_regex(_currentPage, perPage, search, filterDropdown, sortName, sortType);
            if (getAsset) {
                const { status, data, currentPage, perPage, totalPage } = getAsset;
                if (status) {
                    setBankData(data);
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage || 1);
                }
                else {
                    setCurrentPageData([]);
                }
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Error fetching bank regex data:', error);
        }
    };

    useEffect(() => {
        getBankRegexData(currentPage, sortData, isAscending);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, deleteUpdateYes, search, currentPage, perPage, filterDropdown, sortData, isAscending]);

    useEffect(() => {
        document.title = title;
    }, [title]);

    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });
    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'Bank_Regex')
            setPagePermissions({
                ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D
            })
        }
    }, [tokenType, permissions])


    useEffect(() => {
        setFormData({ countryCode: '' })
    }, [])
    return (
        <div>
            <SearchAndAddBtn title={`Bank Regex`} addBtn={false} isSearch={true} countryFilter={false} perPageCount={true} />
            <div className='grid grid-cols-12'>
                <div class="flex items-start col-span-4 justify-center p-10">
                    <div class="mx-auto w-full max-w-[550px]">
                        <form onSubmit={handleSubmit}>
                            <div class="mb-5">
                                <label
                                    htmlFor="countryCode"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    Country
                                </label>
                                <input
                                    type="text"
                                    name="countryCode"
                                    value={formData?.countryCode || ''}
                                    onChange={handleChange}
                                    required
                                    placeholder="Bank Country"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>
                            <div class="mb-5">
                                <label
                                    htmlFor="name"
                                    class="mb-3 block text-base font-medium text-[#07074D]" >
                                    Bank Name
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData?.name || ''}
                                    onChange={handleChange}
                                    required
                                    placeholder=" Bank Name"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>

                            <div class="mb-5">
                                <label
                                    htmlFor="regex"
                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                >
                                    Bank Regex
                                </label>
                                <input
                                    type="text"
                                    name="regex"
                                    value={formData?.regex || ''}
                                    onChange={handleChange}
                                    required
                                    placeholder="Enter your Bank Regex"
                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                                />
                            </div>
                            <div>
                                <button
                                    class="hover:shadow-form rounded-md bg-[#0047ff] py-3 px-8 text-base font-semibold text-white outline-none">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className='col-span-8 h-[840px] rounded-md overflow-y-scroll bg-white '>
                    <Card className="overflow-hidden w-full rounded-md shadow-none">
                        <CardBody className="overflow-x-auto w-100 py-8 px-[10px] card-body-scrollbar">
                            <table className="w-full min-w-max table-auto text-left">
                                <THead simpleFields={simpleFields} isSelectAll={false} />
                                <tbody>
                                    {
                                        isLoading ?
                                            <tr>
                                                <td colSpan={totalFields} className='py-12'>
                                                    <div className="flex justify-center items-center">
                                                        <Spinner />
                                                    </div>
                                                </td>
                                            </tr>
                                            : bankData?.length === 0 ?
                                                <tr>
                                                    <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                        <div className="flex justify-center items-center">
                                                            No Data Found
                                                        </div>
                                                    </td>
                                                </tr>
                                                : bankData?.map((_ele, i) => {
                                                    const isLast = i === bankData?.length - 1;
                                                    const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                                    return (
                                                        <tr key={i} className='border-b border-blue-gray-50 '>

                                                            <td className={classes}>
                                                                <div className="flex items-center ml-4">
                                                                    <span className={'font-normal text-[17px]'}>{_ele?.countryCode || `None`}</span>
                                                                </div>
                                                            </td>
                                                            <td className={classes}>
                                                                <div className="flex items-center break-words">
                                                                    <span className={'font-normal text-[17px]'}>{_ele?.name || `None`}</span>
                                                                </div>
                                                            </td>
                                                            <td className={classes}>
                                                                <div className="flex items-center break-words">
                                                                    <span className={'font-normal text-[17px]'}>{_ele?.regex || `None`}</span>
                                                                </div>
                                                            </td>

                                                            <td className={classes}>
                                                                <div className="flex items-center gap-2">
                                                                    <IconButton
                                                                        onClick={() => { setDeleteUpdateYes("update-bank-regex"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}
                                                                        className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none'
                                                                    >
                                                                        <BiEdit />
                                                                    </IconButton>
                                                                    <IconButton
                                                                        onClick={() => { setDeleteUpdateYes("delete-bank-regex"); setDeleteUpdateItem({ id: _ele._id }); setConfirmationModalShow(!confirmationModalShow) }} disabled={!pagePermissions?.D}
                                                                        className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none'
                                                                    >
                                                                        <RiDeleteBinLine />
                                                                    </IconButton>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                    }
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                    <BankRegexModel getBankData={getBankRegexData} />
                </div>
            </div>
            {
                totalPage > 1 &&
                <Pagination currentPage={currentPage} totalPage={totalPage} getData={getBankRegexData} />
            }
        </div>
    )
}
BankRegex.defaultProps = {
    title: "Message | BankRegex"
};

export default BankRegex
